// @flow
import SearchResultsController from './SearchResultsController'

export default SearchResultsController
